import { ImplinksCss } from './ImplinksCss'
export function Implinks() {
    return <ImplinksCss>
        <div className="implinks">
            <div>
                <a href="google.com">Terms Of Service</a>
            </div>
            <div>
                <a href="google.com">Privacy Policy</a>
            </div>
            <div>
                <a href="google.com">Contact Us</a>
            </div>
            <div>
                <a href="google.com">Sitemap</a>
            </div>
        </div>
    </ImplinksCss>
}